import React, { useEffect, useState } from 'react';
import { getImageFromAssets } from '../../../utils/helpers/assetHelpers';
import { Heading1, ItemKeahlian } from '../../atoms';

export default function Keahlian() {
  const [dataSkillFilter, setdataSkillFilter] = useState([]);

  const skills = [
    {
      name: 'HTML',
      type: 'BOTH',
      image: getImageFromAssets('/assets/svg/language/html5.svg'),
    },
    {
      name: 'CSS',
      type: 'BOTH',
      image: getImageFromAssets('/assets/svg/language/css.svg'),
    },
    {
      name: 'JavaScript',
      type: 'BOTH',
      image: getImageFromAssets('/assets/svg/language/js.svg'),
    },
    {
      name: 'TypeScript',
      type: 'BOTH',
      image: getImageFromAssets('/assets/svg/language/typescript.svg'),
    },
    {
      name: 'Tailwind CSS',
      type: 'BOTH',
      image: getImageFromAssets('/assets/svg/language/tailwind.svg'),
    },

    {
      name: 'React',
      type: 'FE',
      image: getImageFromAssets('/assets/svg/language/react.svg'),
    },
    {
      name: 'React Native',
      type: 'FE',
      image: getImageFromAssets('/assets/svg/language/react.svg'),
    },
    {
      name: 'Next.js',
      type: 'FE',
      image: getImageFromAssets('/assets/svg/language/next.svg'),
    },

    {
      name: 'MySQL',
      type: 'Database',
      image: getImageFromAssets('/assets/svg/language/mysql.svg'),
    },
    {
      name: 'Firebase',
      type: 'Database',
      image: getImageFromAssets('/assets/svg/language/firebase.svg'),
    },
    {
      name: 'git',
      type: 'ALL',
      image: getImageFromAssets('/assets/svg/language/git.svg'),
    },
    {
      name: 'Figma',
      type: 'ALL',
      image: getImageFromAssets('/assets/svg/language/figma.svg'),
    },
  ];

  useEffect(() => {
    setdataSkillFilter(skills);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="keahlian"
      className="section relative bg-white mt-12 p-8 pb-20"
      style={{
        minHeight: '65vh',
      }}>
      <div className="relative flex justify-center items-center">
        <Heading1 heading={'KEAHLIAN'} />
      </div>

      <div className="relative mt-10 grid grid-cols-2 lg:grid-cols-4 gap-6 md:mx-auto container max-w-7xl transition-all duration-300">
        {dataSkillFilter.map((item) => (
          <ItemKeahlian item={item} key={item.name} />
        ))}
      </div>
    </div>
  );
}
